//dependencias
import React, { Component } from 'react';

//componentes
import CitasAction from './cita'

class Index extends Component {

    render(){
        return(
            <div>
                <CitasAction />
            </div>
        );
    }

}
export default Index;